import React, { useRef } from "react";
import { useFieldArray, Controller } from "react-hook-form";
import Button from "@/components/Button/Button";
import DeleteIcon from "@/components/SVGComponents/DeleteIcon";
import { Input } from "../Input/Input";
import Select from "../Select/Select";
import withLabelAndError from "../withLabelAndError";
import { getInitialValues } from "@/lib/utils";
import styles from "../../../pages/DistributorMerchant/SupplierManagement/Order/Order.module.scss";

const FieldArray = (props: any) => {
  const {
    control,
    name,
    slabFields,
    label,
    addButtonText = "",
    showAddButton = true,
    className,
  } = props;
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const addItem = () => {
    append(getInitialValues(slabFields));
  };

  return (
    <div className={className || ""}>
      {/* Label */}
      {/* {label && <label className="block font-semibold text-gray-700">{label}</label>}/ */}

      {/* Field Rows */}
      {fields.map((item, index) => (
        <>
          <div key={item.id} className={styles.productRow}>
            {Object.entries(slabFields as Record<string, any>).map(
              ([fieldName, fieldProps]) => {
                const fieldElement = control ? (
                  <Controller
                    key={fieldName}
                    name={`${name}[${index}][${fieldName}]`}
                    control={control}
                    rules={fieldProps.validations || {}}
                    render={({ field }) =>
                      fieldProps.controlType === "select" ? (
                        <div>
                          <Select
                            {...field}
                            options={fieldProps.options || []}
                            placeholder={
                              fieldProps.placeholder ||
                              `Select ${fieldProps.label}`
                            }
                            controlType={fieldProps.controlType}
                            isRequired={fieldProps.isRequired || false}
                            errorMessage={fieldProps.errorMessage || ""}
                          />
                        </div>
                      ) : (
                        <Input
                          {...field}
                          type={fieldProps.controlType}
                          placeholder={
                            fieldProps.placeholder ||
                            `Enter ${fieldProps.label}`
                          }
                        />
                      )
                    }
                  />
                ) : (
                  <Input
                    key={fieldName}
                    name={`${name}[${index}][${fieldName}]`}
                    type={fieldProps.controlType}
                    placeholder={
                      fieldProps.placeholder || `Enter ${fieldProps.label}`
                    }
                  />
                );

                return <div key={fieldName}>{fieldElement}</div>;
              }
            )}
          </div>
          <div className={styles.rowActions}>
            {showAddButton && (
              <span className={styles.addMore} onClick={addItem}>
                Add more
              </span>
            )}

            {index !== 0 && (
              <span className={styles.deleteRow} onClick={() => remove(index)}>
                Delete
              </span>
            )}
          </div>
        </>
      ))}
    </div>
  );
};

const FieldArrayWithLabelAndError = withLabelAndError(FieldArray);

export default FieldArrayWithLabelAndError;
export { FieldArray };
